import { render } from "./purchaseForm.vue?vue&type=template&id=ae317456&scoped=true"
import script from "./purchaseForm.vue?vue&type=script&lang=js"
export * from "./purchaseForm.vue?vue&type=script&lang=js"

import "./purchaseForm.vue?vue&type=style&index=0&id=ae317456&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae317456"]])

export default __exports__